import React from 'react';
import { Badge } from '@/components/ui/badge';

interface ShortTurnHeaderProps {
  title?: string;
  description?: string;
  isCustomized?: boolean;
  context?: 'user' | 'client';
  noCard?: boolean;
}

export const ShortTurnHeader: React.FC<ShortTurnHeaderProps> = ({
  title,
  description,
  isCustomized,
  context = 'user',
  noCard
}) => {
  if (noCard || (!title && !description)) return null;

  return (
    <div className="space-y-1 text-center mb-4">
      {title && (
        <div className="flex items-center justify-center gap-3">
          <h3 className="heading-label text-lg text-foreground">{title}</h3>
          {isCustomized && <Badge variant="default">{context === 'client' ? 'Client' : 'Profile'} Override</Badge>}
        </div>
      )}
      {description && <p className="text-sm text-muted-foreground px-2">{description}</p>}
    </div>
  );
};
